import * as React from 'react';
import  './event.scss';
import Moment from "react-moment";
export interface IProps{
    phrases;
    GetContactRelatedMails;
    CurrentEmail;
}
export default class ContactRecentCorrespondence extends React.Component<IProps>{
    public state ={loading:true,currentview:'notes'};
    public maillists=[];
    constructor(props) {
        super(props);
        this.LoadContactEmails(this.maillists);
      }
    
    public render() {
        
        return (
            <div style={{padding:"0px 15px"}}>
                {this.state.loading?(
                     <div style={{margin:'o auto'}} className="mipaloading">&nbsp;</div>
                ):(
                    <div className="outlookeventassignecontainer">
                        <span  onClick={()=>{this.changeviw("notes");}} className="attendeetype typeselected">Emails</span>
                                            
                        <div className="attendeelist attendeelistactive">
                            {this.maillists}
                        </div>
                    </div>
          
                )}
                
            </div>
        
        );
    }
    private changeviw=(newview)=>{
        if(this.state.currentview!=newview){
            this.setState({currentview:newview});
        }
    }
    private LoadContactEmails=(mailitems)=>{
        let fnsuccess=(response)=>{
            if(response && response.data && response.data.value && response.data.value.length>0){
                response.data.value.map((mail,index)=>{
                    mailitems.push(
                        <div key={mail.id} className="mailitem" title={mail.bodyPreview}>
                            <a className="mailsubject" href={mail.webLink} target="_blank">
                            {mail.hasAttachments?(<i className="ms-Icon ms-Icon--Attach" />):null}
                                {mail.subject}
                                </a>
                             <div className="mailsender">
                                <div style={{width:'48%',float:"left"}}>
                                <span className="texteclips" title={this.Prepaterecepienttitle(mail.from.emailAddress)} >{mail.from.emailAddress.name}</span>
                                </div>
                               <div style={{width:'48%',float:"right"}}>
                                    {this.preparetolist(mail.toRecipients)}
                                </div> 
                                <div className="clear" />
                            </div>
                            <div>
                            <Moment format="DD MMM YY hh:mm A">{mail.sentDateTime}</Moment>
                            <span style={{float:'right',textTransform:'capitalize'}}>{mail.importance}</span>
                            </div> 
                        </div>
                    );
                });
            }
            this.setState({loading:false});
            
        }
        this.props.GetContactRelatedMails(this.props.CurrentEmail, fnsuccess);
    }
    private preparetolist=(tolist)=>{
        let tolistui=[];
        let seperator='';
        tolist.forEach(element => {
            tolistui.push(
            <span title={this.Prepaterecepienttitle(element.emailAddress)}>{seperator}{element.emailAddress.name}</span>
            );
            seperator=', ';
        });
        return tolistui;
    } 
    private Prepaterecepienttitle=(address)=>{
        let title='';
        title=address.name+'('+address.address+')';
        return title;
    }
}